export const SPREADSHEET_TYPE = {
    individual: 1,
    pedigree: 2
};

export const OPERATOR_MAPPING = {
      'EQUALS': 1,
      'IS_LESS_THAN': 2,
      'IS_GREATER_THAN': 3,
      'DOES_NOT_EQUAL': 4,
      'IS_LESS_THAN_OR_EQUAL_TO': 5,
      'IS_GREATER_THAN_OR_EQUAL_TO': 6,
      'IS_BLANK': 7,
      'IS_NOT_BLANK': 8,
      'BEGINS_WITH': 9,
      'DOES_NOT_BEGIN_WITH': 10,
      'ENDS_WITH': 11,
      'DOES_NOT_END_WITH': 12,
      'CONTAINS': 13,
      'DOES_NOT_CONTAIN': 14,
      'IN': 15,
      'IS_NOT_IN': 16,
      'LIKE': 17,
      'IS_NOT_LIKE': 18,
      'IS_NULL': 19,
      'IS_NOT_NULL': 20,
      // Aggregate operators
      'AVG': 100,
      'COUNT': 101,
      'MAX': 102,
      'MIN': 103,
      'SUM': 104,
      'CONCAT': 105
};
    
export const SPREADSHEET_DEFAULTS = {
  WIDTH: 100,
};

export const SPREADSHEET_FIELD_CONTEXT = {
  INDIVIDUAL: "IDS_CONTEXT",
  PEDIGREE: "PDS_CONTEXT",
};
